import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { closeModal } from '@/reducers/ui/ui.redux'
import { CreatableInput } from '@/components/forms/CreatableInput'
import { Button } from '@/components/buttons/Button'
import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'

export const AddCampaignModal = ({ onSubmit, dropdownOptions = [], loading = false }) => {
  const dispatch = useDispatch()
  const { currentlyOpenModalId } = useSelector((state) => state.ui)
  const [selectedPlaybook, setSelectedPlaybook] = useState(null)
  const [voipCampaignNames, setVoipCampaignNames] = useState([])
  const isOpen = currentlyOpenModalId === 'voip-campaign-add'

  useEffect(() => {
    if (isOpen) {
      setVoipCampaignNames([])
      setSelectedPlaybook(null)
    }
  }, [isOpen])

  const handleClose = () => {
    dispatch(closeModal())
  }

  const handleSubmit = async () => {
    if (!selectedPlaybook) {
      return
    }

    if (isEmpty(voipCampaignNames)) {
      return
    }

    await onSubmit({
      campaignName: voipCampaignNames,
      configCid: selectedPlaybook,
      isEdit: false,
      isUnmatchedEdit: false,
      editingCampaign: null,
    })
    handleClose()
  }

  const isFormValid = selectedPlaybook && !isEmpty(voipCampaignNames)

  return (
    <BasicModal
      title="Add VoIP Campaign"
      onClose={handleClose}
      show={currentlyOpenModalId === 'voip-campaign-add'}
      size="tiny"
    >
      <div className="field-stack">
        <FormField required>
          <label>Campaign Name</label>
          <div className="voip-customer-id-search-container medium-gap">
            <CreatableInput
              placeholder="Enter VoIP Campaign Names"
              value={voipCampaignNames}
              data-testid="campaign-name-input"
              handleUpdateFilters={(_, newValue) => {
                const seen = []
                newValue.forEach((item) => {
                  if (!seen.find((v) => v.value === item.value)) {
                    seen.push(item)
                  }
                })
                setVoipCampaignNames(seen)
              }}
              disabled={loading}
            />
          </div>
        </FormField>
        <FormField required>
          <label>Playbook</label>
          <Select
            placeholder="Select Playbook"
            options={dropdownOptions}
            name="config_cid"
            onChange={(option) => {
              setSelectedPlaybook(option?.value)
            }}
            value={selectedPlaybook}
            isDisabled={loading}
            required
          />
        </FormField>
        <div className="modal-footer">
          <Button
            data-testid="dismiss-button"
            disabled={loading}
            onClick={() => {
              handleClose()
            }}
          >
            Dismiss
          </Button>
          <Button
            data-testid="confirm-button"
            brand
            onClick={handleSubmit}
            disabled={!isFormValid || loading}
            disabledTooltip="Please fill out all required fields"
            loading={loading}
          >
            Save
          </Button>
        </div>
      </div>
    </BasicModal>
  )
}
